/**
 * Cadwork writes a 0-byte lock file named `.~Model.3d` while the model is open.
 * Uploading that lock file (instead of the .3d beside it) is what suppliers
 * then download as an empty, unopenable model.
 */
export function projectFileUploadBlockReason(file: { name: string; size: number }): string | null {
  const base = (file.name || '').split(/[/\\]/).pop() || '';
  if (/^(?:\.~|~\$)/.test(base)) {
    return 'This is a Cadwork lock file, not the model. Close it in Cadwork and upload the .3d file without the .~ prefix.';
  }
  if (!file.size) {
    return 'This file is empty (0 KB) and was not uploaded.';
  }
  return null;
}
